import { call, takeLatest, put } from 'redux-saga/effects';
import getAPI from 'core/api/iv-back';

import { YieldOf } from 'types/utils';
import { sagaWithCallback } from 'core/store/utils';
import { logout } from '../api-auth/actions';

import { fetchSendStatus } from './actions';

export function* fetchSendStatusSaga() {
  const { getSendStatus } = getAPI();
  const response: YieldOf<typeof getSendStatus> = yield call(getSendStatus);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    return data;
  } else {
    throw new Error('fetch sendStatus failed: ' + problem);
  }
}

export default function* saga() {
  yield takeLatest(fetchSendStatus.type, sagaWithCallback(fetchSendStatusSaga));
}
